import { RootComponentInstance } from "@uniformdev/canvas";
import { UniformEntryPage } from "src/pages/uniform-entry/uniform-entry-page";
import { useWAEContext } from "src/uniform/utils/wae-context-provider";

import FeatureGates from "@atlaskit/feature-gate-js-client";
import UFOSegment from "@atlaskit/react-ufo/segment";
import { ProductKeys } from "@atlassiansox/asc-stargate";

import { CrossFlowTouchpointProvider } from "@/components/cross-flow/touchpoint";
import {
    useLoggedInHasJira,
    useJiraD0to6,
    useJiraW2AndAfterOrMultipleJiras
} from "@/components/user-context";
import { IntercomProvider } from "@/libraries/intercom/src";
import { LoggedInJiraProductTourOverview } from "@/templates/software/jira/logged-in/logged-in-jira/templates";
import { LoggedInHeroContainer } from "@/templates/software/jira/logged-in/organic-d1to6-logged-in/logged-in-hero-container";
import { OrganicD1to6LoggedInJiraProductTourOverview } from "@/templates/software/jira/logged-in/organic-d1to6-logged-in/organic-d1to6-logged-in-jira-product-tour-overview.template";
import { LoggedOutOrNoJiraProductTourOverview } from "@/templates/software/jira/logged-out/jira-software-logged-out-page/src";
import { experiments, ExperimentView } from "@/utils/experiment";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

export const JiraSoftwarePage = () => {
    const loggedInHasJira = useLoggedInHasJira();
    const jiraD0to6 = useJiraD0to6();
    const W2AndAfterOrMultipleJiras = useJiraW2AndAfterOrMultipleJiras();
    const loggedInSkeletonEnabled = checkFeatureFlagGate(
        featureFlags.jfindLoggedInJiraProductTourSkeleton
    );

    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom: boolean = FeatureGates.checkGate(
        "gwp-737-enable-intercom-chat-jsw"
    );

    const isWae = checkFeatureFlagGate(
        featureFlags.dxpMigrationJiraProductTourGate
    );

    const template = W2AndAfterOrMultipleJiras ? (
        <ExperimentView
            experiment={
                experiments.jfind1506AfterD7GetOrganicUsersBackToProduct
            }
            render={(value) => {
                switch (value) {
                    case "jfind-1506-after-d7-gubtp-organic":
                        return (
                            <OrganicD1to6LoggedInJiraProductTourOverview
                                experimentValue={
                                    "jfind-1506-after-d7-gubtp-organic"
                                }
                            />
                        );
                    default:
                        return <LoggedInJiraProductTourOverview />;
                }
            }}
        />
    ) : jiraD0to6 ? (
        <OrganicD1to6LoggedInJiraProductTourOverview
            experimentValue={"not-enrolled"}
        />
    ) : loggedInHasJira ? (
        <LoggedInJiraProductTourOverview />
    ) : isWae ? (
        <WaeJiraPage />
    ) : (
        <LoggedOutOrNoJiraProductTourOverview />
    );

    return (
        <UFOSegment name="jira-product-tour-overview">
            <IntercomProvider appId={"p0ww63i2"} triggerBoot={isBootIntercom}>
                <CrossFlowTouchpointProvider
                    productKeys={[ProductKeys.JIRA_SOFTWARE]}
                    screenName="wacJswProductTourPage"
                >
                    {loggedInSkeletonEnabled ? ( //Feature Gate checks for logged in users
                        <LoggedInHeroContainer>
                            {template}
                        </LoggedInHeroContainer>
                    ) : (
                        template
                    )}
                </CrossFlowTouchpointProvider>
            </IntercomProvider>
        </UFOSegment>
    );
};

const WaeJiraPage = () => {
    const { composition } = useWAEContext();

    return (
        <UniformEntryPage composition={composition as RootComponentInstance} />
    );
};
